/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeckPitchSelfPublishFileType {
  readonly id: string;
  readonly name: string;
  readonly tag: string | null;
  readonly slug: string | null;
  readonly inactive: boolean;
}
